import type { ReactNode } from "react";
import { RoundButtonLink } from "cy-ui/components/RoundIcons";
import { cn } from "cy-fe/src/utils/cn";
import { XIcon, ArrowLeftIcon } from "lucide-react";

export function MinimalPageContainer({
  closeUrl,
  closeType,
  fillContentArea = false,
  headerChildren,
  children,
  contentClassName,
  className,
  headerClassName,
}: {
  closeType?: "back" | "close";
  closeUrl?: string;
  fillContentArea?: boolean;
  children: ReactNode;
  contentClassName?: string;
  className?: string;
  headerClassName?: string;
  headerChildren: ReactNode;
}) {
  return (
    <div className={cn("flex min-h-screen flex-col ring-black", className)}>
      <MinimalPageHeader
        className={headerClassName}
        closeUrl={closeUrl}
        closeType={closeType}
      >
        {headerChildren}
      </MinimalPageHeader>
      {/* Allow child to take over the container*/}
      <div className="relative flex flex-1">
        {" "}
        <div
          className={cn(
            "mx-auto mt-8 w-full max-w-[52rem] flex-grow sm:mt-16",
            !fillContentArea && "pb-10",
            contentClassName,
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export function MinimalPageHeader({
  closeUrl,
  closeType,
  children,
  className,
}: {
  closeUrl?: string;
  closeType?: "back" | "close";
  children: ReactNode;
  className?: string;
}) {
  const Icon = closeType === "back" ? ArrowLeftIcon : XIcon;
  return (
    <nav
      className={cn(
        "border-outline flex items-center justify-center border-b p-6 px-5 sm:px-8",
        className,
      )}
    >
      <div className="flex w-full max-w-[60rem] items-center justify-between gap-5">
        {children}
        {!!closeUrl && <RoundButtonLink href={closeUrl} icon={Icon} />}
      </div>
    </nav>
  );
}
